export default __webpack_public_path__ + "static/media/Multiple-girl.d2e193fa.png";